<template>
  <div class="landing">
    <!-- 1. HERO SECTION (New Strategic Pivot) -->
    <LandingHero
      v-if="!loadingUserLoginStatus && !user.loggedIn"
      @login="toggleLoginModal"
      @register="toggleRegisterModal"
    />

    <!-- 2. PRODUCT DEMO (The Feed) -->
    <div class="singleColumn fullWidth">
      <YourUnitverse />
    </div>

    <!-- 3. FOOTER -->
    <div v-if="!loadingUserLoginStatus && !user.loggedIn" class="separator fullWidth"></div>
    <LandingFooter
      v-if="!loadingUserLoginStatus && !user.loggedIn"
      variant="landing"
    />
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { auth } from "@/firebase";
import YourUnitverse from "@/components/DashboardComponents/YourUnitverse.vue";
import LandingHero from "@/components/LandingComponents/LandingHero.vue";
import LandingFooter from "@/components/LandingComponents/LandingFooter.vue";

export default {
  name: "Landing",
  components: {
    LandingHero,
    YourUnitverse,
    LandingFooter,
  },
  setup() {
    const loadingUserLoginStatus = ref(true);

    const store = useStore();
    const router = useRouter();
    const activeTab = computed(() => store.getters.activeTab);
    // watch(activeTab, (newValue) => {
    //   console.log("activeTab:", newValue);
    //   console.log("Show YourUnitverse:", newValue === "yourUnitverse");
    //   console.log("Show Ecosystem:", newValue === "ecosystem");
    // });

    const loginModalVisible = computed(() => store.state.showLoginModal);
    const registerModalVisible = computed(() => store.state.showRegisterModal);
    const goToAbout = () => {
      router.push("/about");
      store.dispatch("changeActiveTab", null);
    };
    const toggleLoginModal = () => store.dispatch("toggleLoginModal");
    const toggleRegisterModal = () => store.dispatch("toggleRegisterModal");

    onMounted(async () => {
      auth.onAuthStateChanged((user, userCredentials) => {
        store.dispatch("fetchUser", user);
        store.dispatch("fetchUserCredentials", user); // Assuming user object has the credentials
        loadingUserLoginStatus.value = false;
      });
    });

    const changeTab = (tabName) => {
      console.log(tabName);
      store.dispatch("changeActiveTab", tabName);
    };

    const currentYear = new Date().getFullYear();

    const user = computed(() => {
      return store.getters.user;
    });

    const userCredentials = computed(() => {
      return store.getters.userCredentials;
    });

    return {
      user,
      goToAbout,
      activeTab,
      loginModalVisible,
      toggleLoginModal,
      registerModalVisible,
      toggleRegisterModal,
      loadingUserLoginStatus,
      userCredentials,
      currentYear,
    };
  },
};
</script>

<style scoped>
.landing {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  gap: var(--space-8);
  width: 100%;
}

.logo_container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.rotated_logo {
  max-height: 100%;
}

.desktop-side-by-side {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--space-5);
  padding: 0 var(--space-4);
  margin-bottom: var(--space-8);
}

.side-column {
  width: 100%;
}

.button-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

/* DESKTOP SCREENS */
@media only screen and (min-width: 768px) {
  .desktop-side-by-side {
    flex-direction: row;
    justify-content: center;
    gap: var(--space-8);
  }

  .side-column {
    width: 45%;
    max-width: 500px;
  }
}

/* SMALL AND MEDIUM SCREENS */
@media only screen and (max-width: 767px) {
  .desktop-side-by-side {
    flex-direction: column;
    width: 100%;
  }

  .side-column {
    width: 100%;
    max-width: 100%;
    margin-bottom: var(--space-8);
  }

  .faq-column {
    order: 2; /* Display FAQ below CreateOrJoin on mobile */
  }

  .create-join-column {
    order: 1; /* Display CreateOrJoin above FAQ on mobile */
  }
}

/* SMALL SCREENS */
@media only screen and (max-width: 530px) {
  .parent_container {
    width: 100%;
    height: 85vh; /* Set the height of the parent container */
  }

  .rotated_logo {
    transform: rotate(90deg); /* Rotate the image by 90 degrees */
    max-height: 100%; /* Adjust the height of the rotated image */
  }
}
</style>
